
export type GetCourseDetailParams = {
/**
 * 미리보기 모드 활성화 (true일 경우 Draft 데이터 조회)
 */
preview?: boolean;
/**
 * 미리보기 언어 (preview=true일 때만 유효)
 */
previewLanguage?: string;
};
